import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class Watercrafts extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const waterCrafts = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].waterCrafts[0].waterCraft"
      );
      if (waterCrafts) {
        _.forEach(waterCrafts, (record, index) => {
          const leftCells = [];
          const regRecs = [];
          const registration = _.get(record, "registration[0]");
          if (registration !== undefined) {
            getAllRows(
              registration,
              regRecs,
              props,
              _.get(registration, "$.display")
            );
            if (regRecs.length > 0) {
              leftCells.push(
                <Table key={`wat_table_reg_${index}`}>
                  <Table.Body>
                    <Table.Row className="report-sub-sub-section-header">
                      <Table.HeaderCell colSpan={2}>
                        Registration
                      </Table.HeaderCell>
                    </Table.Row>
                    {regRecs}
                  </Table.Body>
                </Table>
              );
            }
          }
          const descRecs = [];
          const description = _.get(record, "description[0]");
          if (description !== undefined) {
            getAllRows(
              description,
              descRecs,
              props,
              _.get(description, "$.display")
            );
            if (descRecs.length > 0) {
              leftCells.push(
                <Table key={`wat_description_table_${index}`}>
                  <Table.Body>
                    <Table.Row className="report-sub-sub-section-header">
                      <Table.HeaderCell colSpan={2}>
                        Description
                      </Table.HeaderCell>
                    </Table.Row>
                    {descRecs}
                  </Table.Body>
                </Table>
              );
            }
          }
          const rightCells = [];
          const owners = _.get(record, "owners[0].owner");
          if (owners !== undefined) {
            _.forEach(owners, (owner, ownerIndex) => {
              const ownerRecs = [];
              getAllRows(owner, ownerRecs, props, _.get(owner, "$.display"));
              if (ownerRecs.length > 0) {
                rightCells.push(
                  <Table key={`wat_owner_table_${index}_${ownerIndex}`}>
                    <Table.Body>
                      <Table.Row className="report-sub-sub-section-header">
                        <Table.HeaderCell colSpan={2}>Owner</Table.HeaderCell>
                      </Table.Row>
                      {ownerRecs}
                    </Table.Body>
                  </Table>
                );
              }
            });
          }
          rows.push(
            <Table.Row key={`wat_row_${index}`}>
              <Table.Cell>{leftCells}</Table.Cell>
              <Table.Cell>{rightCells}</Table.Cell>
            </Table.Row>
          );
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Watercrafts"}
        rows={this.state.rows}
      />
    );
  }
}

export default Watercrafts;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Watercrafts.js